
import React from 'react';
import AdminLayout from '@/components/admin/AdminLayout';

const TemplatesListPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Certificate Templates</h1>
        <p className="mt-4">Manage certificate templates.</p>
      </div>
    </AdminLayout>
  );
};

export default TemplatesListPage;
